import React, { useState, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import {
  StarBorderRounded as StarIcon,
  StarRounded as BookmarkedIcon,
  FileCopyRounded as FileIcon,
} from '@material-ui/icons'
import { useTheme } from '@material-ui/core/styles'
import { useSnackbar } from 'notistack'

import { setConversations } from '../../../redux/conversations/actions'

import messages from '../../../services/messages'
import Typography from '../display/typography'
import Highlight from '../display/highlight'
import HighlightSearch from '../display/highlightSearch'
import IconButton from '../inputs/iconButton'
import CircularProgress from '../feedback/circularProgress'

import useStyles from './balloonSystemStyle'

const BalloonSystem = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const size = useSelector((state) => state.preferences)
  const theme = useTheme()
  let useStylesParams = {
    size: size,
    resize: props?.resize,
  }
  const classes = useStyles(useStylesParams)

  const activeConversation = useSelector((state) => state.activeConversation)
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const messageStore = useSelector(
    (state) => state.conversations.messages[activeConversation]
  )
  const chatKeyword = useSelector((state) => state.keyword)
  const [showActions, setShowActions] = useState(false)
  const [bookmarked, setBookmarked] = useState(props.data.favorite)
  const [loading, setLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const copyToClippboard = (string) => {
    navigator.clipboard.writeText(string).then(
      () => {
        enqueueSnackbar(`${t('commons.copied')}`, {
          variant: 'success',
        })
      },
      (err) => {
        console.error(t('commons.copiedError'), err)
      }
    )
  }

  const handleFavorite = () => {
    setLoading(true)
    messages({
      method: 'patch',
      url: `/tech4h-messages/message/favorite/${props.data.currentId}`,
      data: {
        favorite: bookmarked ? false : true,
      },
    })
      .then((response) => {
        setLoading(false)
        setBookmarked(bookmarked ? false : true)
        let msgs = messageStore
        for (let i = 0; i < msgs.length; i++) {
          if (msgs[i].currentId === props?.data?.currentId) {
            msgs[i].favorite = !bookmarked
            break
          }
        }
        conversation.message = msgs
        dispatch(setConversations(conversation))
      })
      .catch((error) => {})
  }

  const renderActions = () => {
    if (props.showBookmark && showActions && props.data.currentId) {
      return (
        <div className={classes.actions}>
          <IconButton
            size="small"
            color="primary"
            disabled={loading}
            component="span"
            style={{ width: 32, height: 32 }}
            onClick={() => handleFavorite()}
          >
            {bookmarked ? (
              loading ? (
                <CircularProgress size={16} />
              ) : (
                <BookmarkedIcon fontSize="inherit" />
              )
            ) : loading ? (
              <CircularProgress size={16} />
            ) : (
              <StarIcon fontSize="inherit" />
            )}
          </IconButton>
          <IconButton
            size="small"
            color="primary"
            component="span"
            style={{ width: 32, height: 32, marginTop: 5 }}
            onClick={(e) => {
              e.stopPropagation()
              copyToClippboard(props.data.text)
            }}
          >
            <FileIcon fontSize="inherit" style={{ transform: 'scaleX(-1)' }} />
          </IconButton>
          {/* <IconButton
            size="small"
            color="primary"
            component="span"
            style={{ width: 32, height: 32, marginTop: 5 }}
          >
            <RepplyIcon
              fontSize="inherit"
              style={{ transform: 'scaleX(-1)' }}
            />
          </IconButton> */}
        </div>
      )
    } else {
      return <></>
    }
  }

  const renderBookmarked = () => {
    if (bookmarked && !showActions) {
      return (
        <div className={classes.bookmarked} id="bookmarked">
          <BookmarkedIcon
            fontSize="inherit"
            style={{
              fontSize: 18,
              color: theme.palette.primary.main,
            }}
          />
        </div>
      )
    } else {
      return <></>
    }
  }

  const renderHeader = () => {
    return (
      <Typography variant="body1" component="h4">
        <span
          style={{
            marginRight: 6,
            color:
              theme.palette.type === 'dark'
                ? '#fff'
                : theme.palette.primary.secondary,
          }}
        >
          {moment(props?.data?.sentTime).format('HH:mm')}
        </span>
        {t('commons.systemMessage')}
      </Typography>
    )
  }

  const renderText = () => {
    if (props.data.text) {
      if (chatKeyword) {
        return (
          <>
            <HighlightSearch
              text={props.data.text}
              keyword={chatKeyword}
              anchor={props.anchor ? props.anchor : 'chat'}
              copy={false}
            />
          </>
        )
      } else {
        return <Highlight text={props.data.text} />
      }
    }
  }

  return (
    <>
      <div
        id={props.data.currentId}
        className={classes.root}
        onClick={props.onClick}
        style={props.style}
        onMouseEnter={() => setShowActions(true)}
        onMouseLeave={() => setShowActions(false)}
      >
        {renderActions()}
        {props.showBookmark && renderBookmarked()}
        <div className={classes.child}>
          {renderHeader()}
          <Typography
            variant="body1"
            component="p"
            style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}
          >
            <span className={'escapeDragScroll'} style={{ cursor: 'text' }}>
              {renderText()}
            </span>
          </Typography>
        </div>
      </div>
    </>
  )
}

export default memo(BalloonSystem)
